import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-UpperNodeHeight",
  "use": "icon-UpperNodeHeight-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-UpperNodeHeight\"><path d=\"M518.5970051505699 468.8809931921041m-192.82219933590963 0a192.82219744247166 192.82219744247166 0 1 0 385.64439677838124 0 192.82219744247166 192.82219744247166 0 1 0-385.64439677838124 0Z\" p-id=\"11073\" /><path d=\"M494.6508817881752-64.88609325464176h57.545331741102956v1090.484042819181h-57.545331741102956z\" p-id=\"11074\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol